(function () {
  if (window.__nestPdpQuickbuyKeyboardA11y20260723 === 'v6-enter-opener-guard') return;
  window.__nestPdpQuickbuyKeyboardA11y20260723 = 'v6-enter-opener-guard';

  var addInFlight = false;
  var lastHandledAt = 0;
  var lastQuickbuyOpener = null;
  var suppressQuickbuySubmitUntil = 0;
  var focusSelector = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent || '');

  function visible(el) {
    if (!el || !el.getClientRects || !el.getClientRects().length) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
  }

  function focusable(el) {
    return !!(el && !el.disabled && el.getAttribute('aria-hidden') !== 'true' && el.getAttribute('tabindex') !== '-1' && visible(el));
  }

  function quickbuyButton(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest('.quickbuy-modal button[name="add"],.quickbuy-modal .fake-submit,.quickbuy-modal .product-form__cart-submit,.quickbuy-popup button[name="add"],.quickbuy-popup .fake-submit,.quickbuy-popup .product-form__cart-submit');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return null;
    return btn.closest('.quickbuy-modal,.quickbuy-popup') ? btn : null;
  }

  function quickbuyOpenButton(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest('.related-products-container button,.related-product-outer button,.product-detail-description-right-footer button.collection-detail-product-link,.product-detail-description-right-footer .collection-detail-product-link');
    if (!btn || btn.closest('.quickbuy-modal,.quickbuy-popup')) return null;
    var label = (btn.innerText || btn.textContent || btn.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
    return /\+?\s*add/i.test(label) ? btn : null;
  }

  function rememberOpener(target) {
    var opener = quickbuyOpenButton(target);
    if (opener) lastQuickbuyOpener = opener;
  }

  function restoreOpenerFocus() {
    if (!lastQuickbuyOpener || !document.documentElement.contains(lastQuickbuyOpener) || !visible(lastQuickbuyOpener)) return;
    [80, 220, 420].forEach(function (delay) {
      setTimeout(function () {
        var active = document.activeElement;
        var badLanding = !active || active === document.body || active === document.documentElement || (active.matches && active.matches('.skip-link,.in-page-link,[href="#MainContent"]'));
        if (!badLanding) return;
        try { lastQuickbuyOpener.focus({ preventScroll: true }); } catch (e) { lastQuickbuyOpener.focus(); }
      }, delay);
    });
  }

  function quickbuyCloseButton(target) {
    return target && target.closest && target.closest('.quickbuy-modal .popup-close-icon,.quickbuy-modal [aria-label="Close quick buy dialog"],.quickbuy-popup .popup-close-icon,.quickbuy-popup [aria-label="Close quick buy dialog"]');
  }

  function activeQuickbuyModal() {
    return Array.prototype.slice.call(document.querySelectorAll('.quickbuy-modal,.popup-container.quickbuy-modal')).filter(function (modal) {
      return visible(modal) && modal.getAttribute('aria-hidden') !== 'true';
    })[0] || null;
  }

  function firstQuickbuyBodyControl(modal) {
    var scope = modal && (modal.querySelector('.quickbuy-popup') || modal);
    if (!scope) return null;
    return Array.prototype.slice.call(scope.querySelectorAll(focusSelector)).filter(function (control) {
      if (!focusable(control)) return false;
      if (quickbuyCloseButton(control)) return false;
      return true;
    })[0] || null;
  }

  function scheduleOpenFocus(reason) {
    [90, 220, 420, 700].forEach(function (delay) {
      setTimeout(function () {
        var modal = activeQuickbuyModal();
        var current = document.activeElement;
        var next = firstQuickbuyBodyControl(modal);
        var shouldMove = modal && next && (!current || current === document.body || current === document.documentElement || quickbuyCloseButton(current));
        window.__nestPdpQuickbuyKeyboardLastOpen = {
          at: Date.now(), reason: reason + ' +' + delay,
          modalFound: !!modal,
          activeBefore: current && current.tagName,
          activeClass: current && String(current.className || '').slice(0, 120),
          nextTag: next && next.tagName,
          nextText: next && (next.innerText || next.textContent || next.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 120),
          suppressUntil: suppressQuickbuySubmitUntil
        };
        if (shouldMove) focusControl(next);
      }, delay);
    });
  }

  function quickbuyOption(target) {
    if (!target || !target.closest) return null;
    var option = target.closest('.quickbuy-modal .options li,.quickbuy-modal li.option-flex,.quickbuy-popup .options li,.quickbuy-popup li.option-flex');
    if (!option) return null;
    var modal = option.closest('.quickbuy-modal');
    var popup = option.closest('.quickbuy-popup') || modal;
    var options = option.closest('.options');
    var wrapper = options && (options.closest('.select') || options.parentElement);
    if (!modal || !popup || !wrapper) return null;
    return { option: option, modal: modal, popup: popup, wrapper: wrapper };
  }

  function nextQuickbuyControl(ctx) {
    if (!ctx || !ctx.popup || !ctx.wrapper) return null;
    return Array.prototype.slice.call(ctx.popup.querySelectorAll(focusSelector)).filter(function (control) {
      if (!focusable(control)) return false;
      if (ctx.wrapper.contains(control)) return false;
      if (control.closest && control.closest('.quickbuy-popup-header')) return false;
      if (control.matches && control.matches('select.product-detail-option-select')) return false;
      return !!(ctx.wrapper.compareDocumentPosition(control) & Node.DOCUMENT_POSITION_FOLLOWING);
    })[0] || null;
  }

  function focusControl(control) {
    if (!control || !control.focus) return;
    try { control.focus({ preventScroll: true }); } catch (e) { control.focus(); }
  }

  function scheduleVariantFocus(ctx, reason) {
    [0, 60, 180, 420].forEach(function (delay) {
      setTimeout(function () {
        var current = document.activeElement;
        var close = ctx.popup && ctx.popup.querySelector('.popup-close-icon,[aria-label="Close quick buy dialog"]');
        var next = nextQuickbuyControl(ctx);
        var shouldMove = !current || current === document.body || current === document.documentElement || current === ctx.option || ctx.wrapper.contains(current) || current === close;
        window.__nestPdpQuickbuyKeyboardLastFocus = {
          at: Date.now(), reason: reason + ' +' + delay,
          activeBefore: current && current.tagName,
          activeClass: current && String(current.className || '').slice(0, 120),
          nextTag: next && next.tagName,
          nextText: next && (next.innerText || next.textContent || next.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 120)
        };
        if (shouldMove && next) focusControl(next);
      }, delay);
    });
  }

  function formPayload(button) {
    var form = button.closest('form');
    if (form) return new FormData(form);
    var root = button.closest('.quickbuy-modal,.quickbuy-popup');
    var idField = root && root.querySelector('input[name="id"],select[name="id"]');
    var quantityField = root && root.querySelector('input[name="quantity"],.variant-quantity,input[data-quantity-input]');
    if (!idField || !idField.value) return null;
    var data = new FormData();
    data.append('id', idField.value);
    data.append('quantity', quantityField && quantityField.value || '1');
    return data;
  }

  function closeQuickbuy(button) {
    var modal = button && button.closest('.quickbuy-modal');
    var close = modal && modal.querySelector('.popup-close-icon,[aria-label="Close quick buy dialog"]');
    if (close && close.click) setTimeout(function () { close.click(); restoreOpenerFocus(); }, 30);
  }

  function dispatchMouseClick(el) {
    try {
      el.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
      el.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
      el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    } catch (e) {
      if (el.click) el.click();
    }
  }

  function openCartDrawer() {
    var openers = Array.prototype.slice.call(document.querySelectorAll('.site-header__cart,a.site-header__cart,a[href="/cart"],a[href*="/cart"]')).filter(visible);
    var opener = openers[0] || document.querySelector('.site-header__cart,a.site-header__cart,a[href="/cart"],a[href*="/cart"]');
    if (!opener) return false;
    setTimeout(function () { dispatchMouseClick(opener); }, isSafari ? 260 : 120);
    return true;
  }

  function dispatchCartRefreshEvents(cart, phase) {
    var detail = { source: 'quickbuy-keyboard', phase: phase, cart: cart || null };
    ['refreshAjaxCart', 'refreshCart', 'cart:refresh'].forEach(function (name) {
      try { window.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) { window.dispatchEvent(new Event(name)); }
      try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e2) { document.dispatchEvent(new Event(name)); }
    });
  }

  function callUpdateCart(phase) {
    if (typeof window.UpdateCart !== 'function') return false;
    try {
      window.UpdateCart();
      if (window.__nestPdpQuickbuyKeyboardLastAdd) {
        window.__nestPdpQuickbuyKeyboardLastAdd.updateCartCalls = window.__nestPdpQuickbuyKeyboardLastAdd.updateCartCalls || [];
        window.__nestPdpQuickbuyKeyboardLastAdd.updateCartCalls.push({ at: Date.now(), phase: phase });
      }
      return true;
    } catch (error) {
      if (window.__nestPdpQuickbuyKeyboardLastAdd) {
        window.__nestPdpQuickbuyKeyboardLastAdd.updateCartError = error && error.message;
      }
      return false;
    }
  }

  function refreshCartThenOpen() {
    return fetch('/cart.js?nest_quickbuy_refresh=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (res) { return res.ok ? res.json() : null; }).catch(function () { return null; }).then(function (cart) {
      if (window.__nestPdpQuickbuyKeyboardLastAdd) {
        window.__nestPdpQuickbuyKeyboardLastAdd.cartAfterAdd = cart && { item_count: cart.item_count, total_price: cart.total_price };
      }
      dispatchCartRefreshEvents(cart, 'after-cart-read');
      callUpdateCart('before-open');
      dispatchCartRefreshEvents(cart, 'after-updatecart-before-open');
      setTimeout(function () {
        dispatchCartRefreshEvents(cart, 'delayed-before-open');
        openCartDrawer();
        setTimeout(function () {
          callUpdateCart('after-open');
          dispatchCartRefreshEvents(cart, 'after-open');
        }, isSafari ? 620 : 180);
      }, isSafari ? 980 : 220);
    });
  }

  function submitQuickbuy(button, source) {
    var now = Date.now();
    if (now < suppressQuickbuySubmitUntil) {
      window.__nestPdpQuickbuyKeyboardSuppressedAdd = { at: now, source: source, label: (button.innerText || button.textContent || button.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim() };
      return;
    }
    if (addInFlight || now - lastHandledAt < 700) return;
    var data = formPayload(button);
    if (!data) {
      window.__nestPdpQuickbuyKeyboardLastAdd = { at: now, source: source, ok: false, error: 'No quickbuy form payload found' };
      return;
    }
    lastHandledAt = now;
    addInFlight = true;
    button.setAttribute('aria-busy', 'true');
    window.__nestPdpQuickbuyKeyboardLastAdd = {
      at: now,
      source: source,
      method: 'cart-add-api-v6',
      label: (button.innerText || button.textContent || button.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim(),
      payload: Array.prototype.slice.call(data.entries()),
      safari: isSafari
    };
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: data })
      .then(function (res) { if (!res.ok) throw new Error('Cart add failed: ' + res.status); return res.json(); })
      .then(function (item) {
        window.__nestPdpQuickbuyKeyboardLastAdd.ok = true;
        window.__nestPdpQuickbuyKeyboardLastAdd.item = item && { id: item.id, title: item.title, quantity: item.quantity, key: item.key };
        closeQuickbuy(button);
        return refreshCartThenOpen();
      })
      .catch(function (error) {
        window.__nestPdpQuickbuyKeyboardLastAdd.ok = false;
        window.__nestPdpQuickbuyKeyboardLastAdd.error = error && error.message;
      })
      .finally(function () {
        addInFlight = false;
        button.removeAttribute('aria-busy');
      });
  }

  function consume(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  document.addEventListener('focusin', function (event) { rememberOpener(event.target); }, true);
  document.addEventListener('pointerdown', function (event) { rememberOpener(event.target); }, true);
  document.addEventListener('mousedown', function (event) { rememberOpener(event.target); }, true);
  document.addEventListener('click', function (event) {
    rememberOpener(event.target);
    if (quickbuyCloseButton(event.target)) setTimeout(restoreOpenerFocus, 40);
  }, true);

  document.addEventListener('keydown', function (event) {
    var key = event.key;
    if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar') return;
    var opener = quickbuyOpenButton(event.target);
    if (opener && key === 'Enter') {
      consume(event);
      lastQuickbuyOpener = opener;
      suppressQuickbuySubmitUntil = Date.now() + 1400;
      window.__nestPdpQuickbuyKeyboardLastAdd = undefined;
      window.__nestPdpQuickbuyKeyboardSuppressedAdd = undefined;
      window.__nestPdpQuickbuyKeyboardLastOpen = { at: Date.now(), reason: 'quickbuy opener Enter', label: (opener.innerText || opener.textContent || opener.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim() };
      setTimeout(function () { dispatchMouseClick(opener); scheduleOpenFocus('quickbuy opener Enter'); }, 0);
      return;
    }
    rememberOpener(event.target);
    if (quickbuyCloseButton(event.target)) setTimeout(restoreOpenerFocus, 40);
    var add = quickbuyButton(event.target);
    if (add) {
      consume(event);
      submitQuickbuy(add, 'keydown ' + key);
      return;
    }
    var ctx = quickbuyOption(event.target);
    if (!ctx) return;
    if (key === ' ' || key === 'Spacebar') {
      event.preventDefault();
      if (ctx.option.click) ctx.option.click();
    }
    scheduleVariantFocus(ctx, 'quickbuy keyboard variant option ' + key);
  }, true);

  document.addEventListener('click', function (event) {
    var add = quickbuyButton(event.target);
    if (!add) return;
    var keyboardGenerated = event.detail === 0 || event.pointerType === '';
    if (!keyboardGenerated) return;
    consume(event);
    submitQuickbuy(add, 'keyboard click');
  }, true);

  document.addEventListener('keyup', function (event) {
    var key = event.key;
    if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar') return;
    if (!quickbuyButton(event.target) && !quickbuyOpenButton(event.target)) return;
    consume(event);
  }, true);
})();
